import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, Zap, Users, MapPin, ArrowLeft, Clock, Smartphone } from 'lucide-react';
import './AboutPage.css';

export default function AboutPage() {
  const navigate = useNavigate();

  return (
    <div className="about-page-container">
      {/* HEADER SIMPLIFICADO */}
      <header className="header">
        <div className="header-container">
          <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            ACHEVAM <span>•</span>
          </div>
          <button className="back-btn" onClick={() => navigate('/')}>
            <ArrowLeft size={18} /> Voltar para o Início
          </button>
        </div>
      </header>

      <main className="about-main">
        {/* SEÇÃO HERO */}
        <section className="about-hero">
          <h1>Sua jornada começa com a <span>informação certa.</span></h1>
          <p className="subtitle">
            O ACHEVAM nasceu para organizar o transporte complementar e conectar você ao seu destino com agilidade e transparência.
          </p>
        </section>

        {/* GRID DE VALORES */}
        <section className="about-values-grid">
          <div className="value-card">
            <div className="icon-circle-about"><Clock size={28} /></div>
            <h3>Tempo é Valor</h3>
            <p>Sabemos que cada minuto conta. Centralizamos horários para que você não perca tempo esperando no ponto.</p>
          </div>

          <div className="value-card">
            <div className="icon-circle-about"><ShieldCheck size={28} /></div>
            <h3>Segurança Primeiro</h3>
            <p>Conectamos passageiros apenas a transportes e empresas verificadas, promovendo viagens mais seguras.</p>
          </div>

          <div className="value-card">
            <div className="icon-circle-about"><Smartphone size={28} /></div>
            <h3>Fácil de Usar</h3>
            <p>Tecnologia intuitiva feita para todos. Busque, encontre e reserve pelo WhatsApp em poucos segundos.</p>
          </div>
        </section>

        {/* TEXTO INSTITUCIONAL */}
        <section className="about-text-content">
          <div className="text-block">
            <h2>Nossa Missão</h2>
            <p>
              O <strong>ACHEVAM</strong> surgiu da necessidade de modernizar um setor vital para a economia regional: o transporte complementar de passageiros. Percebemos que, enquanto o mundo se digitalizava, as informações sobre vans e micro-ônibus continuavam fragmentadas em grupos de redes sociais ou panfletos físicos.
            </p>
            <p>
              Nossa missão é democratizar o acesso à informação. Através da nossa plataforma, passageiros ganham previsibilidade em suas rotas e empresas de transporte ganham visibilidade, profissionalizando a conexão entre cidades vizinhas.
            </p>
          </div>

          <div className="text-block">
            <h2>Tecnologia e Mobilidade</h2>
            <p>
              Não somos apenas um site de busca; somos uma ferramenta de apoio à mobilidade urbana. Acreditamos que cidades conectadas prosperam mais rápido. Por isso, trabalhamos constantemente para atualizar nossa base de dados e oferecer o melhor caminho para o seu dia a dia, seja para trabalho, estudo ou lazer.
            </p>
          </div>
        </section>
      </main>

      <footer className="modern-footer">
        © 2026 Achevam • Tecnologia em Transporte
      </footer>
    </div>
  );
}